<template>
  <section>
    <el-dialog
      :visible="editForm.visible"
      :title="this.name"
      width="66%"
      :close-on-click-modal="false"
      :before-close="closeBefore"
      center
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="境外收款人：" prop="overseasPayeeNo">
          <el-select
            v-model="editForm.overseasPayeeName"
            value-key="payeeNo"
            style="width: 400px"
            placeholder="选择"
            @change="getPayeeValue($event)"
          >
            <el-option
              v-for="item in overseasPayeeList"
              :key="item.payeeNo"
              :label="item.accountName"
              :value="item"
            />
          </el-select>
          <el-button
            type="primary"
            style="margin-right: 20px; margin-left: 20px"
            size="medium"
            @click="handleAdd()"
            >新增</el-button
          >
        </el-form-item>
        <el-form-item label="收款方账号：">
          <el-input
            v-model="editForm.overseasPayeeAccount"
            style="width: 400px"
            maxlength="100"
            disabled="disabled"
          />
        </el-form-item>
        <el-form-item label="收款方名称：">
          <el-input
            v-model="editForm.overseasPayeeName"
            style="width: 400px"
            maxlength="100"
            disabled="disabled"
          />
        </el-form-item>
        <el-form-item label="常用结算币种：">
          <el-input
            style="width: 400px"
            v-model="editForm.settlementCurrencyName"
            maxlength="100"
            disabled="disabled"
          />
        </el-form-item>
        <el-form-item label="业务类型：" prop="businessType">
          <el-select
            v-model="editForm.businessType"
            placeholder="选择"
            style="width: 400px"
          >
            <el-option
              v-for="item in businessTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            style="margin-right: 20px; margin-left: 20px"
            size="medium"
            :loading="downloadLoading"
            @click="downloadRestore(editForm.declareNo, editForm.merNo)"
            >还原明细下载</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="openUpload()"
            >还原明细上传</el-button
          >
          <span v-show="editForm.uploadDeclareFileName" style="margin-left: 12px">{{
            editForm.uploadDeclareFileName
          }}</span>
          <el-button
            v-show="downloadRestoreVisible"
            type="primary"
            style="margin-left: 12px"
            size="medium"
            :loading="downloadLoading"
            @click="downloadRestoreResult()"
            >失败原因详情</el-button
          >
        </el-form-item>

        <!-- <el-form-item
          label="已上传图片："
          style="display: inline-block; margin-right: 15px"
        >
          <see-workOrderPictureSaveParam
            ref="seeWorkOrderPictureSaveParam"
            :src-list="this.srcList"
            :src-list1="this.srcList1"
            :upload-arr="uploadArr"
          />
        </el-form-item> -->

        <el-form-item label="附件上传：">
          <span style="color: red">支持图片、Zip格式压缩包上传</span>
        </el-form-item>

        <el-form-item>
          <abUploaderMulti
            style="margin-bottom: 12px"
            ref="hetongMultiRef"
            title="合同"
            :required="true"
            accept="image/*,application/zip"
            @previewImage="previewImage"
          ></abUploaderMulti>
          <abUploaderMulti
            style="margin-bottom: 12px"
            ref="fapiaoMultiRef"
            title="发票"
            :required="true"
            accept="image/*,application/zip"
            @previewImage="previewImage"
          ></abUploaderMulti>
          <abUploaderMulti
            style="margin-bottom: 12px"
            ref="baoguanMultiRef"
            title="报关单据"
            accept="image/*,application/zip"
            @previewImage="previewImage"
          ></abUploaderMulti>
          <abUploaderMulti
            style="margin-bottom: 12px"
            ref="wuliuMultiRef"
            title="物流单据"
            accept="image/*,application/zip"
            @previewImage="previewImage"
          ></abUploaderMulti>
          <abUploaderMulti
            style="margin-bottom: 12px"
            ref="otherMultiRef"
            title="其他"
            accept="image/*,application/zip"
            @previewImage="previewImage"
          ></abUploaderMulti>
        </el-form-item>

        <el-form-item label="是否换汇：" prop="isExchange">
          <el-radio-group v-model="editForm.isExchange">
            <el-radio-button label="1">是</el-radio-button>
            <el-radio-button label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="附言：" prop="rmk">
          <el-input
            v-model="editForm.rmk"
            style="width: 400px"
            type="textarea"
            placeholder="请输入内容"
            maxlength="50"
            rows="3"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          style="margin-right: 20px; margin-left: 120px"
          size="medium"
          :loading="declareLoading"
          @click="declareComfirm()"
          >提交</el-button
        >
        <!-- <el-button type="primary" style="margin-right: 20px; margin-left: 120px" size="medium" @click="printAll()">打印值</el-button> -->
      </div>
    </el-dialog>

    <!-- 新增收款人对话框 -->
    <el-dialog
      title="添加境外收款人"
      :visible.sync="addDetailFormVisible"
      :close-on-click-modal="false"
      width="860px"
      :before-close="closeAddDialog"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addFormRule"
        inline
        label-width="160px"
      >
        <!-- 这里没有用到 -->
        <!-- <el-form-item label="收款人编号">
          <el-input v-model="addForm.payeeNo" disabled />
        </el-form-item> -->

        <el-form-item label="商户编号">
          <el-input v-model="addForm.merNo" disabled />
        </el-form-item>

        <el-form-item label="商户名称">
          <el-input v-model="addForm.merName" disabled />
        </el-form-item>

        <el-form-item label="收款方名称" prop="accountName">
          <el-input v-model="addForm.accountName" />
        </el-form-item>

        <el-form-item label="收款账号" prop="accountNo">
          <el-input
            v-model="addForm.accountNo"
            @blur="check_banknum($event, 'accountNo')"
          />
        </el-form-item>

        <el-form-item label="收款人地址" prop="receiverAddr">
          <el-input v-model="addForm.receiverAddr" />
        </el-form-item>

        <el-form-item label="开户行名称" prop="bankName">
          <el-input v-model="addForm.bankName" />
        </el-form-item>

        <el-form-item label="开户行地址" prop="bankAddr">
          <el-input v-model="addForm.bankAddr" />
        </el-form-item>

        <el-form-item label="开户行swift BIC" prop="bankSwiftBic">
          <el-input v-model="addForm.bankSwiftBic" />
        </el-form-item>

        <el-form-item label="收款人常驻国家名称:" prop="countryName">
          <el-select
            v-model="addForm.countryName"
            value-key="paramKey"
            filterable
            placeholder="全部"
            @change="getCountryValue($event)"
          >
            <el-option
              v-for="item in countryOptions"
              :key="item.paramKey"
              :label="item.paramValue"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="收款人常驻国家代码">
          <el-input v-model="addForm.countryCode" disabled />
        </el-form-item>

        <el-form-item label="常用结算币种:" prop="settlementCurrencyName">
          <el-select
            v-model="addForm.settlementCurrencyName"
            value-key="paramKey"
            filterable
            placeholder="全部"
            @change="getCurrencyValue($event)"
          >
            <el-option
              v-for="item in currencyOptions"
              :key="item.paramKey"
              :label="item.paramValue"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="结算币种代码">
          <el-input v-model="addForm.settlementCurrencyCode" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="saveData">提交</el-button>
        <el-button @click.native="closeAddDialog">取消</el-button>
      </div>
    </el-dialog>

    <!-- 新增收款人对话框 -->
    <payee-dialog ref="payeeDialog" @query="queryDataList" />

    <!--文件导入-->
    <el-dialog
      width="40%"
      title="上传文件"
      :visible.sync="importInnerDialog"
      :close-on-click-modal="false"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        ref="tooladdFile"
        :inline="true"
        :model="tooladdFile"
        class="form-search"
        :rules="fileRules"
      >
        <el-row style="margin-top: 15px">
          <el-form-item label="还原文件：" prop="file">
            <el-upload
              ref="upload"
              v-model="tooladdFile.file"
              style="display: flex"
              class="upload-demo"
              :auto-upload="false"
              action="111"
              :file-list="fileList"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            >
              <el-button slot="trigger" size="medium" type="primary"
                >上传文件</el-button
              >
            </el-upload>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="success"
          :loading="uploadFileLoading"
          @click="importFile()"
          >确定</el-button
        >
        <el-button type="primary" @click="handleClose()">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="本批次"
      :visible.sync="feeFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="feeForm" :model="feeForm" label-width="150px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="跨境申报总额">
              <el-input v-model="feeForm.totalAmount" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跨境付款总额">
              <el-input v-model="feeForm.paymentAmount" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="跨境手续费总计">
              <el-input v-model="feeForm.totalFee" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="跨境付款手续费">
              <el-input v-model="feeForm.crossBorderFee" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跨境付款电报费">
              <el-input v-model="feeForm.telegramFee" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="跨境中间行手续费">
              <el-input v-model="feeForm.intermediateFee" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="换汇手续费">
              <el-input v-model="feeForm.exchangeFee" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="当前手续费账户余额">
              <el-input v-model="feeForm.balance" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="loading" @click.native="submitDeclare"
          >提交</el-button
        >
        <el-button @click.native="feeFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-image-viewer
      v-if="imageViewerVisible"
      style="z-index: 100000"
      :url-list="imgList"
      :on-close="() => (imageViewerVisible = false)"
      to="body"
    />
  </section>
</template>
<script>
import File from "@/utils/file";
import Session from "@/utils/session";
import {
  declarationFileDownload,
  queryMerVerifyFileList,
  againDeclareDetailSubmit,
} from "@/api/crossborder/declare/restore/declare";
import {
  querySetInfoList,
  queryItemCode,
  insertData,
} from "@/api/crossborder/collection/abroadCollection";
import seeWorkOrderPictureSaveParam from "@/views/crossborder/paymentInquiry/workOrderPictureSaveParam";
import compress from "@/utils/compress";
import imgSize from "@/utils/imgSize";
import Common from "@/utils/common"; // 工具类
import CommonApi from "@/api/common/common";
import payeeDialog from "../collection/payeeDialog.vue";
import abUploaderMulti from "@/components/abuploader/abUploaderMulti";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "Edit",
  components: {
    "see-workOrderPictureSaveParam": seeWorkOrderPictureSaveParam,
    payeeDialog,
    abUploaderMulti,
    ElImageViewer
  },
  data: function () {
    return {
      loading: false,
      listLoading: false,
      aa: null,
      merNo: null,
      declareNo: null,
      overseasPayeeList: [],
      downloadRestoreVisible: false,
      declareConfirmVisible: false,
      importInnerDialog: false,
      swapDialog: false,

      downloadLoading: false,
      uploadFileLoading: false,
      declareLoading: false,

      tooladdFile: {
        file: null,
      },
      fileList: [],
      fileRules: {
        file: [{ required: true, message: "请选择文件", trigger: "blur" }],
      },
      srcList: [],
      srcList1: [],
      addForm: {
        merNo: "",
        merName: "",
        payeeNo: "",
        accountName: "",
        accountNo: "",
        receiverAddr: "",
        bankName: "",
        bankAddr: "",
        bankSwiftBic: "",
        countryName: "",
        countryCode: "",
        settlementCurrencyName: "",
        settlementCurrencyCode: "",
      },
      addFormRule: {
        accountName: [
          { required: true, message: "请填写收款方名称", trigger: "change" },
        ],
        accountNo: [
          { required: true, message: "请填写收款方账号", trigger: "change" },
        ],
        receiverAddr: [
          { required: true, message: "请填写收款方地址", trigger: "change" },
        ],
        bankName: [
          { required: true, message: "请填写开户行名称", trigger: "change" },
        ],
        bankAddr: [
          { required: true, message: "请填写开户行地址", trigger: "change" },
        ],
        bankSwiftBic: [
          {
            required: true,
            message: "请填写开户行swift BIC",
            trigger: "change",
          },
        ],
        countryName: [
          {
            required: true,
            message: "请选择收款人常驻国家名称",
            trigger: "change",
          },
        ],
        settlementCurrencyName: [
          { required: true, message: "请选择常用结算币种", trigger: "change" },
        ],
      },
      dicForm1: {
        paramKey: "",
        paramValue: "",
      },
      dicForm2: {
        paramKey: "",
        paramValue: "",
      },
      errUrl: null,
      countryOptions: [],
      currencyOptions: [],
      addDetailFormVisible: false,
      feeFormVisible: false,
      feeForm: {
        paymentAmount: null,
        totalAmount: null,
        totalFee: null,
        crossBorderFee: null,
        telegramFee: null,
        intermediateFee: null,
        exchangeFee: null,
        balance: null,
      },
      // 编辑路由表单
      editForm: {
        visible: false,
        loading: false,
        merNo: null,
        declareNo: null,
        payeeNo: null,
        payeeCode: null,
        overseasPayeeAccount: null,
        overseasPayeeName: null,
        settlementCurrencyName: null,
        businessType: null,
        restoreFile: null,
        restoreResultFile: null,
        contractUrl: "",
        invoiceUrl: "",
        customsDeclareUrl: "",
        logisticsUrl: "",
        otherUrl: null,
        isExchange: null,
        rmk: null,
        fileList: [],
        fileNo: null,
        uploadDeclareFileName: null,
      },
      item1: {
        title: "发票",
        imgKey: "invoiceUrl",
        hide: false,
        fileType: "02",
      },
      rules: {
        overseasPayeeNo: [
          { required: true, message: "请选择收款人", trigger: "blur" },
        ],
        businessType: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        isExchange: [
          { required: true, message: "请选择是否换汇", trigger: "blur" },
        ],
      },
      uploadArr: [
        {
          title: "合同",
          imgKey: "contractUrl",
          hide: false,
          required: false,
          fileType: "03",
        },
        {
          title: "发票",
          imgKey: "invoiceUrl",
          hide: false,
          required: false,
          fileType: "02",
        },
        {
          title: "报关单据",
          imgKey: "customsDeclareUrl",
          hide: false,
          required: false,
          fileType: "05",
        },
        {
          title: "物流单据",
          imgKey: "logisticsUrl",
          hide: false,
          required: false,
          fileType: "06",
        },
        {
          title: "其它",
          imgKey: "otherUrl",
          hide: false,
          required: false,
          fileType: "07",
        },
      ],
      businessTypeList: [{ value: "00", label: "B2B货物贸易" }],

      imageViewerVisible: false,
      imgList: [],
      previewIndex: 0,
    };
  },
  created() {
    this.queryDataList(); // 查询付款人列表
    this.getCountryAreaCode();
    this.getCurrencyCode();
  },
  beforeMount() {
    this.name = "重新申报";
  },
  methods: {
    /**
     * 检查是否为银行号码
     *
     */
    check_banknum(event, propertyName) {
      let value = event.target.value.replace(/[^\w]/g, "");
      if (value.length > 25) {
        value = value.slice(0, 24);
      }
      this.addForm[propertyName] = value;
    },

    previewImage(url) {
      this.imgList = [url];
      this.previewIndex = 0;
      this.imageViewerVisible = true;
    },

    // 编辑弹窗
    openEdit: function (index, row) {
      this.editForm.visible = true;
      this.editForm.payeeCode = row.payeeCode;
      this.editForm.payeeNo = row.payeeCode;
      this.editForm.overseasPayeeName = row.payeeAccName;
      this.editForm.overseasPayeeAccount = row.payeeAccNo;
      this.editForm.settlementCurrencyName = row.currencyName;
      this.editForm.merNo = row.merNo;
      this.editForm.declareNo = row.declareNo;
      this.editForm.isExchange = row.exchangeMark;
      this.editForm.businessType = "00";
      this.editForm.rmk = "";

      // 图片相关
      this.srcList = [];
      this.serList1 = [];

      // 清空还原明细上传的变量
      this.fileList = [];
      this.editForm.fileNo = null;

      this.editForm.fileList = []; // 清空上传图片或者文件的东西

      this.queryMerVerifyFileList(row.declareNo);
      /*      this.fileList.push({ 'url': 'https://dev-saas.mfe88.com/file-api/api/FILE_VIEW?code=0DfubBKAzPk' }) */
      
    },
    // 查询列表
    queryDataList() {
      this.listLoading = true;
      const param = {
        merNo: this.$store.getters.merNo,
      };
      this.overseasPayeeList = [];
      querySetInfoList(param)
        .then((res) => {
          if (res.data) {
            res.data.forEach((item) => {
              item.accountName =
                item.accountName + "(" + item.settlementCurrencyName + ")";
            });
            this.overseasPayeeList = res.data;
          }
        })
        .catch((err) => {
          this.listLoading = false;
          console.log(err);
        });
    },
    closeBefore() {
      // console.log('3232323232323')

      this.editForm = {
        visible: false,
        loading: false,
        merNo: null,
        declareNo: null,
        payeeNo: null,
        payeeCode: null,
        overseasPayeeAccount: null,
        overseasPayeeName: null,
        settlementCurrencyName: null,
        businessType: null,
        restoreFile: null,
        restoreResultFile: null,
        contractUrl: "",
        invoiceUrl: "",
        customsDeclareUrl: "",
        logisticsUrl: "",
        otherUrl: null,
        isExchange: null,
        rmk: null,
        fileList: [],
        fileNo: null,
        uploadDeclareFileName: null,
      };

      this.srcList = [];

      // 清空图片回显
      this.$refs.hetongMultiRef.setImgArr([]);
      this.$refs.fapiaoMultiRef.setImgArr([]);
      this.$refs.baoguanMultiRef.setImgArr([]);
      this.$refs.wuliuMultiRef.setImgArr([]);
      this.$refs.otherMultiRef.setImgArr([]);

    },
    // 查询商户申报的附件集合
    queryMerVerifyFileList(declareNo) {
      const param = {
        declareNo: declareNo,
      };
      queryMerVerifyFileList(param)
        .then((res) => {
          // console.log('11111111111 :' + response.data)

          this.editForm.fileNo = res.data.fileNo;
          this.editForm.uploadDeclareFileName = res.data.fileName;

          let hetongArr = [];
          res.data.contractFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.path = item.fileUrl;
            item2.type = item.remark;
            item2.canDownload = false;
            item2.canRemove = true;
            item2.uploadSuccess = true;
            item2.downloading = false;
            hetongArr.push(item2);
          });
          this.$refs.hetongMultiRef.setImgArr(hetongArr);

          let fapiaoArr = [];
          res.data.invoiceFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.path = item.fileUrl;
            item2.type = item.remark;
            item2.canDownload = false;
            item2.canRemove = true;
            item2.uploadSuccess = true;
            item2.downloading = false;
            fapiaoArr.push(item2);
          });
          this.$refs.fapiaoMultiRef.setImgArr(fapiaoArr);

          let baoguanArr = [];
          res.data.declarationFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.path = item.fileUrl;
            item2.type = item.remark;
            item2.canDownload = false;
            item2.canRemove = true;
            item2.uploadSuccess = true;
            item2.downloading = false;
            baoguanArr.push(item2);
          });
          this.$refs.baoguanMultiRef.setImgArr(baoguanArr);

          let wuliuArr = [];
          res.data.logisticsFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.path = item.fileUrl;
            item2.type = item.remark;
            item2.canDownload = false;
            item2.canRemove = true;
            item2.uploadSuccess = true;
            item2.downloading = false;
            wuliuArr.push(item2);
          });
          this.$refs.wuliuMultiRef.setImgArr(wuliuArr);

          let otherArr = [];
          res.data.otherFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.path = item.fileUrl;
            item2.type = item.remark;
            item2.canDownload = false;
            item2.canRemove = true;
            item2.uploadSuccess = true;
            item2.downloading = false;
            otherArr.push(item2);
          });
          this.$refs.otherMultiRef.setImgArr(otherArr);

          
          // console.log(this.srcList)
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * 打印一下页面的值
     */
    printAll() {
      console.log("this.editForm", this.editForm);
    },

    /**
     * 确认申报
     */
    declareComfirm() {
      if (!this.editForm.overseasPayeeName) {
        this.$message.error("请先选择境外收款人");
        return;
      }

      if (!this.editForm.fileNo) {
        this.$message.error("请先上传还原明细文件");
        return;
      }

      let hetongArr = this.$refs.hetongMultiRef.getImgArr();
      if (hetongArr.length === 0) {
        this.$message.error("请先上传合同");
        return;
      }

      let fapiaoArr = this.$refs.fapiaoMultiRef.getImgArr();
      if (fapiaoArr.length === 0) {
        this.$message.error("请先上传发票");
        return;
      }

      if (
        this.editForm.isExchange === null ||
        this.editForm.isExchange === undefined
      ) {
        this.$message.error("请先选择是否换汇");
        return;
      }

      const param = {
        merNo: Session.getItem("merNo"),
        fileNo: this.editForm.fileNo,
        isExchange: this.editForm.isExchange,
      };
      this.declareLoading = true;
      // console.log(param)
      CommonApi.declareFeeQuery(param)
        .then((response) => {
          this.declareLoading = false;
          // console.log(response.data)
          this.feeForm = response.data;
          this.feeFormVisible = true;
        })
        .catch((err) => {
          this.declareLoading = false;
          console.log(err);
        });
    },
    submitDeclare() {
      this.loading = true;

      // 获取上传相关数据
      let hetongArr = this.$refs.hetongMultiRef.getImgArr();
      let fapiaoArr = this.$refs.fapiaoMultiRef.getImgArr();
      let baoguanArr = this.$refs.baoguanMultiRef.getImgArr();
      let wuliuArr = this.$refs.wuliuMultiRef.getImgArr();
      let otherArr = this.$refs.otherMultiRef.getImgArr();

      let fileList = [];

      hetongArr.forEach((item) => {
        item.fileType = "03";
        item.imgKey = "contractUrl";
        item.declareNo = "";
        item.merNo = "";
        item.fileProperty = "03";
        item.fileUrl = item.path;
        item.remark = item.type;
        fileList.push(item);
      });
      fapiaoArr.forEach((item) => {
        item.fileType = "02";
        item.imgKey = "invoiceUrl";
        item.declareNo = "";
        item.merNo = "";
        item.fileProperty = "02";
        item.fileUrl = item.path;
        item.remark = item.type;
        fileList.push(item);
      });
      baoguanArr.forEach((item) => {
        item.fileType = "05";
        item.imgKey = "customsDeclareUrl";
        item.declareNo = "";
        item.merNo = "";
        item.fileProperty = "05";
        item.fileUrl = item.path;
        item.remark = item.type;
        fileList.push(item);
      });
      wuliuArr.forEach((item) => {
        item.fileType = "06";
        item.imgKey = "logisticsUrl";
        item.declareNo = "";
        item.merNo = "";
        item.fileProperty = "06";
        item.fileUrl = item.path;
        item.remark = item.type;
        fileList.push(item);
      });
      otherArr.forEach((item) => {
        item.fileType = "07";
        item.imgKey = "otherUrl";
        item.declareNo = "";
        item.merNo = "";
        item.fileProperty = "07";
        item.fileUrl = item.path;
        item.remark = item.type;
        fileList.push(item);
      });

      this.editForm.fileList = fileList;
      // console.log("this.editForm.fileList", this.editForm.fileList);

      const editFormData = Common.setNull(this.editForm);
      const param = Object.assign({}, editFormData);
      // console.log(param)
      againDeclareDetailSubmit(param)
        .then((response) => {
          this.loading = false;
          // console.log(response.data)
          this.$message({
            message: "提交成功，结果请见“跨境申报付款查询”",
            type: "success",
          });
          this.closeBefore()
          this.feeFormVisible = false;
          this.editForm.visible = false;
          this.$parent.declare();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
      // console.log('1111111')
    },
    getPayeeValue(event) {
      // console.log(event);
      this.editForm.overseasPayeeAccount = event.accountNo;
      this.editForm.overseasPayeeName = event.accountName;
      this.editForm.payeeNo = event.payeeNo;
      this.editForm.settlementCurrencyName = event.settlementCurrencyName;
    },
    downloadRestoreResult() {
      this.$confirm("是否下载还原文件失败详情?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const param = Object.assign({
            url: this.errUrl,
          });
          this.downloadLoading = true;
          CommonApi.dataFileDownload(param)
            .then((res) => {
              // console.log(res)
              this.downloadLoading = false;
              let name = "还原明细列表-" + Session.getItem("merNo") + ".xlsx";
              if (name.startsWith('"') && name.endsWith('"')) {
                name = name.substring(1, name.length - 1);
              }
              name = decodeURI(name);
              const blob = new Blob([res.data]);
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.style.display = "none";
              a.href = url;
              a.download = name;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            })
            .catch((error) => {
              this.downloadLoading = false;
              console.log(error); // 请求失败返回的数据
            });
        })
        .catch(() => {
          // 取消操作,按钮设置可用
        });
    },

    getCountryAreaCode() {
      const param = {
        itemCode: "country-area-code",
        size: 300,
      };
      queryItemCode(param)
        .then((res) => {
          this.countryOptions = res.data;
        })
        .catch((error) => {
          //  this.$message.error(error)
          console.log(error);
        });
    },

    getCurrencyCode() {
      const param1 = {
        itemCode: "currency",
        size: 300,
      };
      queryItemCode(param1)
        .then((res) => {
          this.currencyOptions = res.data;
        })
        .catch((error) => {
          // this.$message.error(error)
          console.log(error);
        });
    },

    /**
     * 新增付款人信息对话框
     */
    handleAdd() {
      this.$refs.payeeDialog.open("add");

      // this.addForm.merNo = Session.getItem('merNo')
      // this.addForm.merName = Session.getItem('merName')

      // this.addForm.accountName = ''
      // this.addForm.accountNo = ''
      // this.addForm.bankName = ''
      // this.addForm.bankAddr = ''
      // this.addForm.bankSwiftBic = ''
      // this.addForm.receiverAddr = ''
      // this.countryOptions.countryName = ''
      // this.countryOptions.paramKey = ''
      // this.addForm.countryCode = ''
      // this.currencyOptions.paramKey = ''
      // this.currencyOptions.settlementCurrencyName = ''
      // this.addForm.settlementCurrencyCode = ''
      // this.addDetailFormVisible = true

      // this.$nextTick(() => {
      //   this.$refs.addForm.clearValidate()
      // })
    },

    // 当添加成功后，需要重新查询一下境外收款人

    closeAddDialog() {
      this.addDetailFormVisible = false;
      this.addForm = {
        merNo: "",
        merName: "",
        payeeNo: "",
        accountName: "",
        accountNo: "",
        receiverAddr: "",
        bankName: "",
        bankAddr: "",
        bankSwiftBic: "",
        countryName: "",
        countryCode: "",
        settlementCurrencyName: "",
        settlementCurrencyCode: "",
      };
    },

    // 上传还原文件
    handleUploadRestore(data, fileList) {
      const file = data.file;
      const form = new FormData();
      form.append("file", file);
      form.append("merNo", Session.getItem("merNo"));
      CommonApi.declareDetailUpload(form)
        .then((response) => {
          // console.log(response.data)
          this.editForm.restoreFile = response.data.url;
          this.$message({
            type: "success",
            message: "还原文件上传成功",
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 上传文件
    openUpload() {
      this.importInnerDialog = true;
    },
    importFile() {
      if (this.$refs.upload.uploadFiles.length > 0) {
        // console.log(this.$refs.upload.uploadFiles)
        if (this.$refs.upload.uploadFiles[0]) {
          this.tooladdFile.file = this.$refs.upload.uploadFiles[0];
        }
      } else {
        this.tooladdFile.file = {};
      }
      if (!this.tooladdFile.file.raw) {
        this.$message.error("请先选择文件");
        return;
      }
      const fileObj = this.tooladdFile.file.raw;
      const fileName = this.tooladdFile.file.name;
      const form = new FormData(); // FormData 对象
      form.append("file", fileObj); // 文件对象  'file'是后台接收的参数名
      form.append("merNo", Session.getItem("merNo"));
      this.uploadFileLoading = true;
      CommonApi.declareDetailUpload(form)
        .then((res) => {
          this.uploadFileLoading = false;
          // console.log(res)
          if (res.data.checkCode === "9999") {
            this.errUrl = res.data.filePath;
            this.editForm.fileNo = null;
            this.downloadRestoreVisible = true;
            this.$message({
              message: "上传文件错误",
              type: "error",
            });
          } else {
            this.editForm.fileNo = res.data.fileNo;
            // console.log(res.data.fileNo)
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.editForm.uploadDeclareFileName = fileName;
          }
          this.importInnerDialog = false;
        })
        .catch((error) => {
          this.uploadFileLoading = false;
          console.log(error); // 请求失败返回的数据
        });
    },
    handleClose() {
      this.importInnerDialog = false;
      this.$refs.tooladdFile.resetFields();
      this.fileList = [];
    },
    handleSubmitClose() {
      this.swapDialog = false;
      this.fileList = [];
    },
    getCountryValue(event) {
      // console.log(event)
      this.addForm.countryCode = event.paramKey;
      this.addForm.countryName = event.paramValue;
    },
    getCurrencyValue(event) {
      // console.log(event)
      this.addForm.settlementCurrencyCode = event.paramKey;
      this.addForm.settlementCurrencyName = event.paramValue;
    },
    saveData() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const param = Object.assign({}, this.addForm);
          insertData(param)
            .then((res) => {
              // console.log(res)
              this.$message.success("成功");
              this.queryDataList();
              this.closeAddDialog();
            })
            .catch((error) => {
              this.$message.error(error);
            });
        }
      });
    },
    // 还原文件下载
    downloadRestore(declareNo, merNo) {
      this.$confirm("是否下载还原文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const param = Object.assign(
            {},
            {
              merchantNo: merNo,
              declareNo: declareNo,
            }
          );
          this.downloadLoading = true;
          declarationFileDownload(param)
            .then((res) => {
              // console.log(res)
              this.downloadLoading = false;
              let name = "还原明细列表-" + merNo + ".xlsx";
              if (name.startsWith('"') && name.endsWith('"')) {
                name = name.substring(1, name.length - 1);
              }
              name = decodeURI(name);
              const blob = new Blob([res.data]);
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.style.display = "none";
              a.href = url;
              a.download = name;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            })
            .catch((error) => {
              this.downloadLoading = false;
              console.log(error); // 请求失败返回的数据
            });
        })
        .catch(() => {
          // 取消操作,按钮设置可用
        });
    },
    beforeUploadRestore(file) {
      var fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      // console.log('fileType:' + fileType)
      const typeList = ["xls", "xlsx"];
      var allow = false;
      var typ = null;
      for (typ in typeList) {
        if (typeList[typ].toLowerCase() === fileType.toLowerCase()) {
          allow = true;
          break;
        }
      }
      if (!allow) {
        this.$message({
          message: "上传文件格式错误",
          type: "warning",
        });
        return false;
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message({
          message: "上传文件大小不能超过5MB",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    // 删除this.editForm.fileList中类型为type的值
    delFileList(type) {
      if (this.editForm.fileList.length > 0) {
        this.editForm.fileList.some((item, i) => {
          if (item.fileProperty === type) {
            this.editForm.fileList.splice(i, 1);
            return true;
          }
        });
      }
    },
    // this.srcList中有  第一个数组是type 则更新 否则新增
    updateSrcList(type, url) {
      if (this.srcList.length > 0) {
        var isAdd = true;
        this.srcList.some((item, i) => {
          if (item[0] === type) {
            this.srcList.splice(i, 1, [type, url]);
            isAdd = false;
            return true;
          }
        });
        if (isAdd) {
          this.srcList.push([type, url]);
        }
      }
    },
    delSrcList(type) {
      if (this.srcList.length > 0) {
        this.srcList.some((item, i) => {
          if (item[0] === type) {
            this.srcList.splice(i, 1);
            return true;
          }
        });
      }
    },
    // 图片上传change事件
    handleChange(file, fileList, item) {
      item.hide = fileList.length >= 1;
    },
    // 图片删除事件
    handleRemove(file, fileList, item) {
      item.hide = fileList.length >= 1;
      this.delFileList(item.fileType);
      this.delSrcList(item.fileType);
    },
    // 上传图片
    handleUpload(data, fileList, item) {
      const file = data.file;
      console.log("我正在上传文件", file);
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        compress(file, 100).then((res) => {
          const form = new FormData();
          form.append("file", res);
          File.upload(form)
            .then((response) => {
              // 先过删掉之前tem.fileType 类型 在this.editForm.fileList的值
              this.delFileList(item.fileType);
              const fileInfo = {
                fileProperty: item.fileType,
                fileUrl:
                  "/files/file-service/file/" +
                  response.data.path +
                  response.data.name +
                  "." +
                  response.data.extension,
                previewUrl: response.data.url,
              };
              this.editForm.fileList.push(fileInfo);
              this.updateSrcList(item.fileType, response.data.url);
              this.$message({
                type: "success",
                message: "图片上传成功",
              });
            })
            .catch((error) => {
              console.error(error);
            });
        });
      } else {
        const form = new FormData();
        form.append("file", file);
        File.upload(form)
          .then((response) => {
            // 先过删掉之前tem.fileType 类型 在this.editForm.fileList的值
            this.delFileList(item.fileType);
            const fileInfo = {
              fileProperty: item.fileType,
              fileUrl:
                "/files/file-service/file/" +
                response.data.path +
                response.data.name +
                "." +
                response.data.extension,
              previewUrl: response.data.url,
            };
            this.editForm.fileList.push(fileInfo);
            this.$message({
              type: "success",
              message: "图片上传成功",
            });
            // console.log(this.uploadArr)
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      // console.log('fileType:' + fileType)
      const typeList = ["jpg", "png", "jpeg", "zip"];
      var allow = false;
      var typ = null;
      for (typ in typeList) {
        if (typeList[typ].toLowerCase() === fileType.toLowerCase()) {
          allow = true;
          break;
        }
      }
      if (!allow) {
        this.$message({
          message: "上传文件格式错误",
          type: "warning",
        });
        return false;
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message({
          message: "上传文件大小不能超过5MB",
          type: "warning",
        });
        return false;
      }
      return true;
    },

    // 重置
    clearUp() {
      this.$refs.createForm.resetFields();
    },
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
@import "@/styles/common.scss";
.show-img {
  width: 100%;
  max-width: 500px;
  height: 280px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

p {
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.hide .el-upload--picture-card {
  display: none;
}
</style>
